/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import ContactUs from "./contact-us"
import TwitterLogo from "../images/Twitter.svg"
import LinkedInLogo from "../images/Group 87.svg"

import "normalize.css"
import "./layout.scss"

const Layout = ({ children, theme, breadcrumb, nocontact }) => {
  const [showModal, setShowModal] = useState(false)

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      allHubspotForm(
        filter: {
          portalId: { eq: "5630379" }
          id: { eq: "26cfd5d1-41dc-44ae-95c5-c7f2b5a07220" }
        }
      ) {
        edges {
          node {
            id
            portalId
            name
            submitText
            redirect
            formFieldGroups {
              fields {
                label
                name
                required
                fieldType
              }
            }
          }
        }
      }
    }
  `)

  const hubSportForm = data.allHubspotForm.edges[0].node
  const displayModal = () => {
    setShowModal(!showModal)
  }

  const showHideModalOnClickOutSide = e => {
    if (e.target && e.target.className === "modal-backdrop") {
      setShowModal(!showModal)
    }
  }

  return (
    <div className={theme ? `${theme}` : ""}>
      <div class="top-bar">Mission Labs is now part of Gamma, read more <a href="https://www.missionlabs.co.uk/blog/a-gamma-company">here.</a></div>
      <Header
        siteTitle={data.site.siteMetadata.title}
        hubSpotForm={hubSportForm}
      />
      <div className="wrapper">
        <div className="socials mobile-hidden">
          <a
            href="https://www.linkedin.com/company/missionlabs"
            target="_blank"
            rel="noreferrer"
          >
            <img src={LinkedInLogo} alt="" />
          </a>
          {/* <img src={FacebookLogo} /> */}
          <a
            href="https://twitter.com/MissionLabsHQ"
            target="_blank"
            rel="noreferrer"
          >
            <img src={TwitterLogo} alt="" />
          </a>
          {/* <img src={InstagramLogo} /> */}
        </div>
        <main>
          {breadcrumb && (
            <div className="centre">
              <p className="breadcrumb">
                {breadcrumb && `Home | ${breadcrumb}`}
              </p>
            </div>
          )}
          {children}
        </main>
      </div>
      {nocontact ? (
        <div></div>
      ) : (
        <ContactUs
          hubSpotForm={hubSportForm}
          showModal={showModal}
          displayModal={displayModal}
          showHideModalOnClickOutSide={showHideModalOnClickOutSide}
        />
      )}
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
